import React from 'react';
import { Stack, Text, Button } from '@chakra-ui/react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('InterviewAnalysis error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Stack align="center" mt="64px" mb="32px">
          <Text fontSize="24px" fontWeight="bold" color="neutrals.800" mb="8px">
            Something went wrong
          </Text>
          <Text fontSize="18px" color="neutrals.500" mb="24px">
            {this.state.error?.message || 'An unexpected error occurred. Please try again.'}
          </Text>
          <Button
            color="neutrals.0"
            bg="primary.900"
            borderRadius="8px"
            fontWeight="semibold"
            fontSize="14px"
            p="10px 24px"
            _hover={{ bg: 'primary.700' }}
            onClick={() => window.location.reload()}
          >
            Reload Page
          </Button>
        </Stack>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
